import { CanActivateFn, Router } from '@angular/router';

import { inject } from '@angular/core';
import { map, take } from 'rxjs';
import { AuthService } from '../../shared/services/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.isAuthenticated$.pipe(
    take(1),
    map((isAuthenticated: boolean | null) => {
      if (isAuthenticated === false) {
        router.navigate(['/login']);
        return false;
      }
      return true;
    })
  );
};
